const UseFormLayoutUtils = require('./layout');

const UseFormGroupUtils = module.exports = {};

UseFormGroupUtils.withRequiredLabel = (field = {}) => {

    if (!field.required || !field.label || / \*$/.test(field.label)) {
        return field;
    }

    return {
        ...field,
        label: `${field.label} *`
    };
};

UseFormGroupUtils.resolveGroupFields = ({
    layout = [],
    context,
    conditionTypes,
    getFieldDefinition
}) => {

    return UseFormLayoutUtils.resolveLayout({
        items: layout,
        context,
        conditionTypes
    }).map((layoutItem) => {

        return UseFormGroupUtils.withRequiredLabel({
            ...getFieldDefinition(layoutItem.name),
            ...layoutItem
        });
    });
};

UseFormGroupUtils.filterFieldsByName = ({
    fields = [],
    fieldNames
}) => {

    if (!fieldNames?.length) {
        return fields;
    }

    const allowedNames = new Set(fieldNames);

    return fields.filter((field) => allowedNames.has(field.name));
};

UseFormGroupUtils.getGroupFieldNames = (resolvedFields = []) => {

    return resolvedFields.map((field) => field.name);
};

UseFormGroupUtils.buildGroupComponentProps = ({
    context,
    layout,
    fieldNames,
    conditionTypes,
    getFieldDefinition
}) => {

    const fields = UseFormGroupUtils.filterFieldsByName({
        fields: UseFormGroupUtils.resolveGroupFields({
            layout,
            context,
            conditionTypes,
            getFieldDefinition
        }),
        fieldNames
    });

    return {
        fields,
        fieldNames: UseFormGroupUtils.getGroupFieldNames(fields)
    };
};
